import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import moment from 'moment';

import ImageMessage from './ImageMessage';
import TextMessage from './TextMessage';
import FileMessage from './FileMessage';
import styles from './MessageGroup.scss';
import { Avatar } from '@mssgme/ui';

MessageGroup.propTypes = {
    messages: PropTypes.arrayOf(PropTypes.object).isRequired,
    author: PropTypes.shape({
        name: PropTypes.string.isRequired,
        avatarUrl: PropTypes.string,
    }),
    destination: PropTypes.oneOf(['client', 'organization', 'team']),
};

MessageGroup.defaultProps = {
    destination: 'client',
};

const colorMap = {
    client: 'default',
    organization: 'secondary',
    team: 'warning',
};

function MessageGroup({ messages, author, destination }) {
    const reverse = destination !== 'organization';
    const color = colorMap[destination];

    const renderMessage = (m) => {
        switch (m.type) {
            case 'image':
                return (
                    <ImageMessage
                        key={m._id}
                        text={m.text}
                        thumbnailUrl={m.thumbnailUrl}
                        mediaUrl={m.mediaUrl}
                        timestamp={moment(m.received)}
                        color={color}
                        reverse={reverse}
                    />
                );
            case 'text':
                return (
                    <TextMessage
                        key={m._id}
                        text={m.text}
                        timestamp={moment(m.received)}
                        color={color}
                        reverse={reverse}
                    />
                );
            case 'audio':
            case 'video':
            case 'file':
                return (
                    <FileMessage
                        key={m._id}
                        mediaUrl={m.mediaUrl}
                        mediType={m.mediType}
                        timestamp={moment(m.received)}
                        color={color}
                        reverse={reverse}
                    />
                );
            default:
                throw new Error('Invalid message type');
        }
    };

    return (
        <div className={cn(styles.root, { [styles.reverse]: reverse })}>
            {author && <Avatar className={styles.avatar} size={36} name={author.name} src={author.avatarUrl} />}
            <div className={styles.messages}>{messages.map(renderMessage)}</div>
        </div>
    );
}

export default memo(MessageGroup);
